import { z } from 'zod';

export const produtoSchema = z.object({
  id: z.string().optional(),
  nome: z.string().min(3, 'Nome deve ter no mínimo 3 caracteres').max(100),
  descricao: z
    .string()
    .max(500)
    .optional()
    .nullable()
    .transform((v) => v || undefined),
  categoria: z
    .string()
    .max(50)
    .optional()
    .nullable()
    .transform((v) => v || undefined),
  preco: z.number().positive('Preço deve ser maior que zero'),
  custo: z.number().min(0, 'Custo não pode ser negativo').optional(),
  tamanho: z
    .string()
    .max(10)
    .optional()
    .nullable()
    .transform((v) => v || undefined),
  controlaEstoque: z.boolean().optional(),
  estoqueAtual: z.number().int().min(0, 'Estoque não pode ser negativo').optional(),
  estoqueMinimo: z.number().int().min(0, 'Estoque mínimo não pode ser negativo').optional(),
  // Aceita URL absoluta OU caminho raiz-relativo ("/images/..."): o upload de
  // produto (gerarUploadUrlHandler) devolve de propósito um caminho relativo
  // que bate 1:1 com o comportamento /images/* do CloudFront — .url() sozinho
  // rejeitava esse formato e travava qualquer salvamento com foto anexada
  // (bug 2026-07-16).
  imagemUrl: z
    .string()
    .regex(/^$|^\/|^https?:\/\//, 'URL inválida')
    .optional()
    .nullable()
    .transform((v) => v || undefined),
  codigoBarras: z
    .string()
    .optional()
    .nullable()
    .transform((v) => v || undefined),
  unidadeMedida: z
    .string()
    .optional()
    .nullable()
    .transform((v) => v || undefined),
  ativo: z.boolean().optional(),
});

export type ProdutoSchema = z.infer<typeof produtoSchema>;
